var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNextOutlined = function SvgNextOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.5 1.505c-6.04 0-10.937 4.718-10.937 10.537S6.459 22.58 12.5 22.58s10.938-4.717 10.938-10.537S18.54 1.505 12.5 1.505M12.5 0C5.596 0 0 5.39 0 12.042s5.596 12.042 12.5 12.042S25 18.694 25 12.042 19.404 0 12.5 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.132 16.016.98 1.152 4.166-4.904-4.167-4.903-.979 1.152 3.18 3.751z"
  })));
};
export default SvgNextOutlined;